export default __webpack_public_path__ + "static/media/gallery-image-11-full.eff14751.jpg";